<tau-spin class="default-spin"
    min="1902"
    max="2050"
    :value=year
    loop="enabled"
    roll-height="custom"
    item-height="50"
    momentum-level="1"
    duration="500">
</tau-spin>
